export default __webpack_public_path__ + "static/media/hht2_ep12_speaking_02.6ba002a8.png";